<section class="section" style="margin-top: 0;">
  <div class="section-content">
    <!-- contenuto di esempio START -->
    <div class="container">
      <div class="row mb-3">
        <div class="col-12">
          <h2 class="h2-custom text-primary">{{ title }}</h2>
        </div>
      </div>
      <div class="row">
        <div class="text-custom col-12 " [innerHTML]="text"></div>
      </div>
    </div>
    <!-- contenuto di esempio END -->
  </div>
</section>

